// Radhika craete new signup without subscription

import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast, Zoom } from "react-toastify";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { IoClose } from "react-icons/io5";
import Form from "react-validation/build/form";
import Stripe from "stripe";
import { useForm } from "react-hook-form";
import CheckButton from "react-validation/build/button";
import axios from "axios";

import NewsubscriptionCheckoutForm from "./newCheckout";
import SpinnerComponent from "../../../../components/Loder/spinner";
import { API, STRIPEPUBLICKEY, STRIPESECRETKEY } from "../../../../backend";
import authHeader from "../../../../services/auth-header";
import Helper from "../../../../Helper";

const NewSignup = () => {
  const [clientSecret, setClientSecret] = useState("");
  const [isInputVisible, setInputVisible] = useState(false);
  const [promotionCode, setPromotionCode] = useState("");
  const [payment, setPayment] = useState(null);
  const [customer_id, setCustomer_id] = useState('');

  const options = { clientSecret };

  const stripe = Stripe(STRIPESECRETKEY);
  let navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
  } = useForm();
  const form = useRef();
  const checkBtn = useRef();
  const [email, setEmail] = useState("");
  const [successful, setSuccessful] = useState(false);
  // const [message, setMessage] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [name, setName] = useState("");
  const [company_name, setCompnayName] = useState("");
  const [address, setAddress] = useState("");
  const [country_name, setCountry] = useState([]);
  const [state_name, setState] = useState([]);
  const [city, setCity] = useState("");
  const [zip_code, setZipCode] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [userAllow, setUserAllow] = useState("1");
  const [country, setCountryid] = useState("");
  const [state, setStateid] = useState("");
  const [elements, setElements] = useState(null);
  const [addPro, setAddPro] = useState("");

  // const [stripee, setStripe] = useState(null);
  const [plan, setPlan] = useState("");
  const [companydata, setCompanydata] = useState([]);
  const [companyid, setCompanyid] = useState("");
  const [transactonid, setTransactonidid] = useState("");
  const [userid, setUserid] = useState("");
  const [amount, setAmount] = useState();
  const [paymentintent, setPaymentIntent] = useState("");
  const [paymentintentid, setPaymentIntentID] = useState("");
  const [userdata, setUserData] = useState(false);
  const [updatestripeintent, setUpdatestripeintent] = useState(false);
  const [planData, setplanData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [nextbuttonloading, setNextButtonLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [renewal_date, setRenewal_date] = useState("")
  const fetchCalled = useRef(false);
  const [totalAmount, setTotalAmount] = useState("");
  const [code, setCode] = useState("");
  const [data, setData] = useState([]);
  const [promotionCodeId, setPromotionCodeId] = useState("");
  const [planId, setPlanId] = useState("");
  const [cutId, setcutId] = useState("");
  const [clicked, setClicked] = useState(false);
  const [ipAddress, setIPAddress] = useState("");
  const [subscription_id, setSubscription_id] = useState("");
  const [subscriptiondate, setSubscriptionDate] = useState("");
  const [subscriptionstatus, setSubscriptionStatus] = useState("");
  const [trial_period, setTrial_period] = useState(15)
  const [paymentMethodOption, setPaymentMethodOption] = useState(['Card'])
  const [selectMethod, setSelectMethod] = useState(null)

  // const [client_secretkey, setClientSecretKey] = useState('pi_3OqrpPLKpVRgqWxo0hsT0H7f_secret_t9K2oE7KW7pHgtn7os6UDt7TE')
  const [client_secretkey, setClientSecretKey] = useState("");

  // const stripePromise = loadStripe("pk_test_51Ok9gXKB4IVk1sd9Iv0FkKwdYMwl4OQOBZ4kxAc06I814DeEwgkAr9ifgpMW8Rrutj05t3ek2jjdlWLqVrUPurIm0052GRbdYN"); // starts with pk_
  const stripePromise = loadStripe(STRIPEPUBLICKEY); // starts with pk_

  const generatePassword = () => {
    const uppercaseLetter = String.fromCharCode(
      65 + Math.floor(Math.random() * 26)
    ); // Random uppercase letter
    const lowercaseLetters = Array.from({ length: 2 }, () =>
      String.fromCharCode(97 + Math.floor(Math.random() * 26))
    ).join(""); // Random two lowercase letters
    const digits = Math.floor(100 + Math.random() * 900); // Random three-digit number

    const newPassword = uppercaseLetter + lowercaseLetters + "@" + digits;
    setPassword(newPassword);
  };

  useEffect(() => {
    generatePassword();
  }, []);

  const uservalidation = async () => {
    try {
      const response = await axios
        .post(
          API + "accounting/uservalidation/",
          {
            email,
          },
          { headers: authHeader() }
        )
        .then((response) => {
          if (response.data.success === 0) {
            toast.error(`${response.data.response}`, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              // closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setEmail("");
          }
        });
      await trigger();
    } catch (error) {
      console.error("Error fetching client secret:", error);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const valueofpayment_intent_client_secret = searchParams.get(
      "payment_intent_client_secret"
    );
    setPaymentIntent(valueofpayment_intent_client_secret);
    const param1Value = searchParams.get("plan");
    setPlan(param1Value);
  }, []);

  const getPlan = async () => {
    setLoading(true);
    await axios
      .get(
        API + `paymentsub/subplans/${plan}/`,
        {
          headers: authHeader(),
        }
        // `http://localhost:8000/subplans/${plan}/`
      )
      .then((res) => {
        if (res.data.success === 1) {
          const plans = res.data.response.plan_name;
          const amount = res.data.response.per_user_amount * 12
          setplanData(res.data.response);
          setAmount(amount);
          setTotalAmount(res.data.response.per_user_amount * 12);
          setUserAllow(1);
          setTrial_period(res.data.response.trial_period)
          setLoading(false);
          setPlan(plans);
        }else{
          toast.error(res.data.error, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      });
  };

  useEffect(() => {
    if (plan !== "") {
      getPlan();
    }
  }, [plan]);

  useEffect(() => {
    const getcountry = async () => {
      const res = await fetch(API + "helper/ajax/load-countries/");
      const getcon = await res.json();
      setCountry(await getcon);
    };
    getcountry();
  }, []);

  const handlecountry = (event) => {
    const getcoutryid = event.target.value;
    setCountryid(getcoutryid);
  };

  const handlestate = (event) => {
    const getstateid = event.target.value;
    setStateid(getstateid);
  };

  useEffect(() => {
    if (country !== "") {
      const getstate = async () => {
        const resst = await fetch(
          API + "helper/ajax/load-states/" + country + "/"
        );
        const getst = await resst.json();
        setState(await getst);
      };
      getstate();
    }
  }, [country]);

  useEffect(() => {
    if (userAllow > "1") {
      const value =
        parseInt(parseInt(planData.per_user_amount) * 12) * parseInt(userAllow);
      setAmount(value);
      if (addPro === "") {
        setTotalAmount(value);
      }
    } else {
      const value2 =
        parseInt(parseInt(planData.per_user_amount) * 12) * parseInt(userAllow);
      setAmount(value2);
      if (addPro === "") {
        setTotalAmount(value2);
      }
    }
  }, [userAllow, addPro]);

  const handleApplyPromotion = async () => {
    try {
      const response = await axios.get(
        API + "paymentsub/subscription/promo_code/"
        // "http://localhost:8000/subscription/promo_code/"
      );

      const promotionCodes = response.data.data;
      const code = promotionCodes.map((val) => val.promo_code);
      setCode(code);
      const matchingPromotionCode = promotionCodes.find(
        (code) => code.promo_code === promotionCode
      );
      if (!matchingPromotionCode) {
        toast.error("Promotion code not found", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setPromotionCode("");
        return;
      }
      setPromotionCodeId(matchingPromotionCode.id);
      await axios.get(
        API + `paymentsub/subscription/promo_code/${matchingPromotionCode.id}`
        // `http://localhost:8000/subscription/promo_code/${matchingPromotionCode.id}`
      ).then((res) => {
        if (res.data.success === 1) {
          const paymentData = res.data.data;
          setPayment(paymentData);
          if (paymentData.discount_type === 'amount_off') {
            const discountedAmount = paymentData.discount_value;
            const addpro = amount - discountedAmount;
            setAddPro(discountedAmount);
            setTotalAmount(addpro);
            setInputVisible(false);
            //   setPromotionCode('');
          } else if (paymentData.discount_type === 'percent_off') {
            const percentOff = paymentData.discount_value / 100;
            const originalAmount = amount;
            const discountedAmount = originalAmount * (1 - percentOff);
            const addpro = amount - discountedAmount;
            setAddPro(addpro);
            setTotalAmount(discountedAmount);
            //   setPromotionCode('');
            setInputVisible(false);
          } else {
            console.log("No discount applied");
          }
        } else {
          toast.error(res.data.error, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setPromotionCode("");
        }
      })
    } catch (error) {
      console.error("Error applying promotion code:", error);
    }
  };


  useEffect(() => {
    const currentDate = new Date();

    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + trial_period);

    const futureEndDate = new Date(newDate); 
    futureEndDate.setFullYear(newDate.getFullYear() + 1);

    const startDate = Helper.DatePicker(newDate);
    const endDate = Helper.DatePicker(futureEndDate);

    const currDate = new Date(endDate);
    
    const renewalDate = new Date(currDate);
    renewalDate.setDate(currDate.getDate() - 60);

    const renewal_date = Helper.DatePicker(renewalDate);

    setStart_date(startDate); 
    setEnd_date(endDate); 
    setRenewal_date(renewal_date); 
}, [trial_period]);

  useEffect(() => {
    const fetchPaymentData = async () => {
      try {
        const paymentResponse = await axios.get(
          API + `accounting/retrieve_promotion_code/${promotionCodeId}/`
        );
        const paymentData = paymentResponse.data.data;
        setPayment(paymentData);

        // const total = paymentData.coupon;
        if (paymentData.discount_type === 'amount_off') {
          const discountedAmount = paymentData.discount_value;
          const addpro = amount - discountedAmount;
          setTotalAmount(addpro);
          setAddPro(discountedAmount);
          setInputVisible(false);
          //   setPromotionCode('');
        } else if (paymentData.discount_type === 'percent_off') {
          const percentOff = paymentData.discount_value / 100;
          const originalAmount = amount;
          const discountedAmount = originalAmount * (1 - percentOff);
          const addpro = amount - discountedAmount;
          setAddPro(addpro);
          setTotalAmount(discountedAmount);
          //   setPromotionCode('');
          setInputVisible(false);
        } else {
          console.log("No discount applied");
        }
      } catch (error) {
        console.error("Error fetching payment data:", error);
      }
    };
    if (clicked && amount !== null && promotionCodeId !== null) {
      fetchPaymentData();
    }
  }, [amount, promotionCodeId, clicked]);

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        setIPAddress(data.ip);
      })
      .catch((error) => console.log(error));
    // }
  }, []);

  const handleSubmitNext = async () => {
    setNextButtonLoading(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      if (!fetchCalled.current) {
        fetchCalled.current = true;
        try {
          if (amount !== 0 && planData.per_user_amount !== null) {
            const response = await fetch(
              API + 'paymentsub/subscription/create-payment-intent/', 
              // 'http://localhost:8000/subscription/create-payment-intent/',
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  items: ['item1', 'item2'],
                  amount: amount,
                  plan: plan
                }),
              });

            if (!response.ok) {
              // throw new Error("Network response was not ok");
              toast.error('Network response was not ok', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }

            const data = await response.json();
            setClientSecretKey(data.clientSecret);
            setPaymentIntentID(data.intent_id);
            setNextButtonLoading(false)
          }else{
              toast.error('Amount is required', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
          }
        } catch (error) {
          console.error("Error fetching client secret:", error);
        }
      }
    } else {
      toast.error("Something went wrong, Please log a support ticket or send email to support@athenafintech.com.")
    }
  };

  return (
    <div>
      {/* {loading === true && <SpinnerComponent />} */}
      {nextbuttonloading && <SpinnerComponent />}
      <section>
        <ToastContainer autoClose={2000} theme="colored" transition={Zoom} />
        <div className="page-header section-height-70">
          <div
            className="container"
            style={{
              paddingLeft: "var(--bs-gutter-x, 1.6rem)",
              height: "auto",
            }}
          >
            <div
              className="row"
              style={{
                backgroundColor: "white",
                marginTop: "4%",
                borderRadius: "10px",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <button
                  className="font-weight-bold d-flex"
                  style={{
                    backgroundColor: "#f1e9e9",
                    borderRadius: "5px",
                    border: "none",
                    fontSize: "10px",
                    width: "70px",
                    justifyContent: "center",
                    padding: "5px",
                  }}
                  onClick={() => navigate("/login")}
                >
                  <i class="bi bi-arrow-left"></i>
                  &nbsp;&nbsp;Back
                </button>
                <div style={{ flex: "1", textAlign: "center" }}>
                  <h4 className="text-info text-gradient">
                    <img
                      src={process.env.PUBLIC_URL + "/static/images/logo.png"}
                      alt="Reimazine"
                      style={{
                        maxWidth: "160px",
                        maxHeight: "160px",
                        marginTop: "10px",
                      }}
                    />
                  </h4>
                </div>
              </div>
              <div
                className="col-xl-4 col-lg-5 col-md-6 d-flex flex-column mx-auto mb-4"
                style={{ marginTop: "-23px" }}
              >
                <div className="card mt-4">
                  <div className="card-header pb-0 text-left">
                    <p className="sub" style={{ fontSize: "18px" }}>
                      {planData.name} Subscription
                    </p>
                    <div style={{ color: "black", marginTop: "-1rem" }}>
                      <span className="trial">with {trial_period} days trial</span>
                    </div>
                    <div className="cost">
                      <span>Cost</span>
                      <span>
                        <span>${planData.per_user_amount}</span>
                        <span>/user/month</span>
                      </span>
                    </div>
                    <div className="form-group">
                      <div className="d-flex qty">
                        <span htmlFor="user">Qty</span>
                        <input
                          type="number"
                          min="1"
                          value={userAllow}
                          className="form-control"
                          style={{ marginLeft: "201px" }}
                          placeholder="No of user"
                          name="userAllow"
                          onChange={(e) => {
                            const newValue =
                              Math.max(1, parseInt(e.target.value, 10)) || "";
                            setUserAllow(newValue);
                            setClicked(true);
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="total-cost-per-year">
                        <span>Subtotal</span>
                        <span className="total-cost">
                          $
                          {amount
                            ? (Math.round(amount * 100) / 100).toFixed(2)
                            : "0.00"}
                        </span>
                      </div>
                      <div className="d-flex" style={{ fontSize: "14px" }}>
                        <a
                          href="#"
                          onClick={() => {
                            setInputVisible(!isInputVisible);
                            setPromotionCode("");
                          }}
                        >
                          Add Promotion Code
                        </a>
                      </div>
                    </div>
                    {isInputVisible ? (
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter promotion code"
                          value={promotionCode}
                          onChange={(e) => setPromotionCode(e.target.value)}
                        />
                        <button
                          className="btn btn-primary apply"
                          type="button"
                          onClick={handleApplyPromotion}
                        >
                          Apply
                        </button>
                      </div>
                    ) : addPro !== "" ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "1rem",
                          paddingBottom: "1rem",
                          borderRadius: "4px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#f7f7f7",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "15px",
                              color: "black",
                              padding: "4px",
                              marginRight: "4px",
                            }}
                          >
                            {promotionCode}
                          </span>
                          <button
                            style={{
                              border: "none",
                              backgroundColor: "#f7f7f7",
                              color: "gray",
                              fontSize: "20px",
                            }}
                            onClick={() => {
                              setAddPro("");
                              setPromotionCode("");
                            }}
                          >
                            <IoClose />
                          </button>
                        </div>
                        <span style={{ fontSize: "14px", color: "#1A1A1A80" }}>
                          -$
                          {addPro
                            ? (Math.round(addPro * 100) / 100).toFixed(2)
                            : "0.00"}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="total-cost-per-year">
                      <span>Total cost per year</span>
                      <span className="total-cost">
                        $
                        {totalAmount
                          ? (Math.round(totalAmount * 100) / 100).toFixed(2)
                          : "0.00"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-8 col-lg-5 col-md-6 d-flex flex-column mx-auto"
                style={{ marginTop: "-23px" }}
              >
                <div className="card mt-4 mb-8">
                  <div className="card-body">
                    <>
                      <Form
                        role="form text-left"
                        ref={form}
                        onSubmit={handleSubmit(handleSubmitNext)}
                        action="."
                        method="POST"
                        id="companyForm"
                      // onClick={handleSubmitNext}
                      >
                        {
                          <div className="center red-text">
                            <div className="form-group d-flex">
                              <div className="flex-grow-1 me-3">
                                <label htmlFor="companyname">
                                  Company Name
                                </label>
                                <input
                                  type="text"
                                  name="company_name"
                                  value={company_name}
                                  className="form-control"
                                  placeholder="Company Name"
                                  {...register("company_name", {
                                    onChange: (e) => {
                                      trigger();
                                      setCompnayName(e.target.value);
                                    },
                                    required: true,
                                  })}
                                />
                                <div className="invalid-feedback">
                                  {errors.company_name?.type === "required" &&
                                    "Company name is required"}
                                </div>
                              </div>
                              <div className="flex-grow-1">
                                <label htmlFor="name">Name</label>
                                <input
                                  type="text"
                                  name="name"
                                  value={name}
                                  className="form-control"
                                  placeholder="Name"
                                  {...register("name", {
                                    onChange: (e) => {
                                      trigger();
                                      setName(e.target.value);
                                    },
                                    required: true,
                                  })}
                                />
                                <div className="invalid-feedback">
                                  {errors.name?.type === "required" &&
                                    "Name is required"}
                                </div>
                              </div>
                            </div>
                            <div className="form-group d-flex">
                              <div className="flex-grow-1 me-3">
                                <label htmlFor="email">Email</label>
                                <input
                                  type="email"
                                  value={email}
                                  className="form-control"
                                  placeholder="Email"
                                  name="email"
                                  {...register("email", {
                                    onChange: (e) => {
                                      trigger();
                                      setEmail(e.target.value);
                                    },
                                    onBlur: (e) => {
                                      uservalidation();
                                    },

                                    required: "Enter valid Email",
                                    pattern: {
                                      value:
                                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                      message: "Please enter a valid email",
                                    },
                                  })}
                                />
                                <div className="invalid-feedback">
                                  {errors.email && errors.email?.message}
                                </div>
                              </div>
                              <div className="flex-grow-1">
                                <label htmlFor="phonenumber">
                                  Phone Number
                                </label>
                                <input
                                  type="text"
                                  name="phone_number"
                                  value={phone_number}
                                  className="form-control"
                                  placeholder="Phone Number"
                                  {...register("phone_number", {
                                    onChange: (e) => {
                                      trigger();
                                      setPhoneNumber(e.target.value);
                                    },
                                    required: true,
                                  })}
                                />
                                <div className="invalid-feedback">
                                  {errors.phone_number?.type === "required" &&
                                    "Phone Number is required"}
                                </div>
                              </div>
                            </div>
                            <div className="form-group">
                              <label htmlFor="address">Address</label>
                              <input
                                type="text"
                                name="address"
                                value={address}
                                className="form-control"
                                placeholder="Address"
                                {...register("address", {
                                  onChange: (e) => {
                                    trigger();
                                    setAddress(e.target.value);
                                  },
                                  required: true,
                                })}
                              />
                              <div className="invalid-feedback">
                                {errors.address?.type === "required" &&
                                  "Address is required"}
                              </div>
                            </div>
                            <div className="form-group d-flex flex-wrap">
                              <div className="flex-grow-1 me-3 mb-3">
                                <label htmlFor="country">Country</label>
                                <select
                                  type="text"
                                  name="country_name"
                                  className="form-control"
                                  {...register("country", {
                                    onChange: (e) => {
                                      trigger();
                                      handlecountry(e);
                                    },
                                    required: true,
                                  })}
                                >
                                  <option value="">---Select Country---</option>
                                  {country_name.map((countryget) => (
                                    <option
                                      key={countryget.id}
                                      value={countryget.id}
                                    >
                                      {countryget.name}
                                    </option>
                                  ))}
                                </select>
                                <div className="invalid-feedback">
                                  {errors.country?.type === "required" &&
                                    "Country is required"}
                                </div>
                              </div>
                              <div className="flex-grow-1 me-3 mb-3">
                                <label htmlFor="state">State</label>
                                <select
                                  name="state"
                                  className="form-control"
                                  {...register("state", {
                                    onChange: (e) => {
                                      trigger();
                                      handlestate(e);
                                    },
                                    required: true,
                                  })}
                                >
                                  <option value="">---Select State---</option>
                                  {state_name.map((resst) => (
                                    <option key={resst.id} value={resst.id}>
                                      {resst.name}
                                    </option>
                                  ))}
                                </select>
                                <div className="invalid-feedback">
                                  {errors.state?.type === "required" &&
                                    "State is required"}
                                </div>
                              </div>
                              <div className="flex-grow-1 me-3 mb-3">
                                <label htmlFor="city">City</label>
                                <input
                                  type="text"
                                  name="city"
                                  value={city}
                                  className="form-control"
                                  placeholder="City"
                                  {...register("city", {
                                    onChange: (e) => {
                                      trigger();
                                      setCity(e.target.value);
                                    },
                                    required: true,
                                  })}
                                />
                                <div className="invalid-feedback">
                                  {errors.city?.type === "required" &&
                                    "City is required"}
                                </div>
                              </div>
                            </div>
                            <div className="flex-grow-1 me-3 mb-3">
                              <label htmlFor="zipcode">Zip Code</label>
                              <input
                                type="text"
                                name="zip_code"
                                value={zip_code}
                                className="form-control"
                                style={{ width: "50%" }}
                                placeholder="Zip Code"
                                {...register("zip_code", {
                                  onChange: (e) => {
                                    trigger();
                                    setZipCode(e.target.value);
                                  },
                                  required: true,
                                })}
                              />
                              <div className="invalid-feedback">
                                {errors.zip_code?.type === "required" &&
                                  "Zip Code is required"}
                              </div>
                            </div>
                            <div className="container mt-3">
                              <div className="row" style={{ marginLeft: '-50px' }}>
                                <div className="d-flex justify-content-around flex-wrap">
                                  {paymentMethodOption.map((val, i) => (
                                    <div
                                      key={i}
                                      // className={`mb-4 ${selectMethod === val ? 'border border-primary' : ''}`}
                                      onClick={() => setSelectMethod(val)}
                                      style={{
                                        cursor: 'pointer',
                                        width: 'calc(50% - 5px)',
                                        margin: '1px',
                                      }}
                                    >
                                      <div className="card" style={{
                                        width: '50%',
                                        border: selectMethod === val ? '3px solid #245C7F' : '',
                                        borderRadius: '5px',
                                        boxSizing: 'border-box', // Ensure the card's border does not affect its size
                                        boxShadow:'10px'
                                      }}>
                                        <div className="card-body">
                                          <h5 className="card-title">{val}</h5>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        {client_secretkey !== "" ? (
                          ""
                        ) : (
                          <button className="btn btn-primary" style={{marginTop:'10px'}}>Next</button>
                        )}
                        <CheckButton
                          style={{ display: "none" }}
                          ref={checkBtn}
                        />
                      </Form>
                      <div className="row card-body">
                        <div>
                          {client_secretkey !== ""
                            ? client_secretkey && (
                              <Elements
                                stripe={stripePromise}
                                options={{ clientSecret: client_secretkey }}
                              >
                                <NewsubscriptionCheckoutForm
                                  setIsLoading={setIsLoading}
                                  isLoading={isLoading}
                                  userData={setUserData}
                                  updatestripeintent={setUpdatestripeintent}
                                  updatestate={updatestripeintent}
                                  paymentintentid={paymentintentid}
                                  companydata={companydata}
                                  companyid={companyid}
                                  userid={userid}
                                  transactonid={transactonid}
                                  company_name={company_name}
                                  name={name}
                                  email={email}
                                  phone_number={phone_number}
                                  address={address}
                                  country={country}
                                  state={state}
                                  city={city}
                                  zip_code={zip_code}
                                  userAllow={userAllow}
                                  amount={totalAmount}
                                  sub_amount={amount}
                                  start_date={start_date}
                                  plan={plan}
                                  planId={planData.id}
                                  password={password}
                                  end_date={end_date}
                                  renewal_date={renewal_date}
                                  clientSecret={client_secretkey}
                                  customer_id={customer_id}
                                  subscription_id={subscription_id}
                                  subscription_date={subscriptiondate}
                                  subscription_status={subscriptionstatus}
                                  selectMethod={selectMethod}
                                  code={code}
                                  promotionCode={promotionCode}
                                />
                              </Elements>
                            )
                            : ""}
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NewSignup;
